import { OddsType } from "app/utils/const";
import React, { useEffect, useState } from "react";
import type { IntlShape } from "react-intl";
import { FormattedMessage } from "react-intl";
import * as api from "../../../../api/landingPageGraphApi";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import SegmentedControl from "../../../../components/SegmentedControl/SegmentedControl";
import PublicLayoutContainer from "../../layouts/PublicLayoutContainer/PublicLayoutContainer";
import PublicChart from "../PublicChart/PublicChart";
import "./PublicShowcase.scss";

type Props = {
  intl: IntlShape;
};

const PublicShowcase: React.FC<Props> = () => {
  const [selectedOddsType, setSelectedOddsType] = useState(OddsType.DECIMAL);
  const [data, setData] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState(false);
  const [graphLoaded, setGraphLoaded] = useState(false);

  const changeOddsType = (value: string) => {
    setSelectedOddsType(value);
  };

  const loadEvents = () => {
    setLoading(true);
    setGraphLoaded(false);
    api.fetchDataForLandingPageGraphs({}).then(resp => {
      resp.landingPageGraphs && setData(resp);
      setLoading(false);
      setGraphLoaded(true);
    });
  };

  useEffect(() => {
    loadEvents();
  }, []);

  const getTranslations = (name: string) => {
    const translations = {
      decimal: <FormattedMessage id="global-events-navigation-decimal" />,
      us: <FormattedMessage id="global-events-navigation-us" />,
    };
    return translations[name];
  };

  const tabs = [
    {
      title: getTranslations("decimal"),
      callback: () => changeOddsType(OddsType.DECIMAL),
      isActive: selectedOddsType === OddsType.DECIMAL,
    },
    {
      title: getTranslations("us"),
      callback: () => changeOddsType(OddsType.US),
      isActive: selectedOddsType === OddsType.US,
    },
  ];

  return (
    <div className="public-showcase">
      <PublicLayoutContainer wide={true}>
        <h2 className="public-showcase__title grotesk-font">
          <FormattedMessage tagName="span" id="home-showcase-title" />
        </h2>
        <div className="public-showcase__content">
          <h2 className="public-showcase__sub-title">
            <FormattedMessage
              tagName="span"
              id="home-showcase-recent-closing-odds"
            />
          </h2>
          <SegmentedControl
            className="public-showcase__tabs"
            tabs={tabs}
            tabTypes={OddsType}
            transparent
          />
          {graphLoaded ? (
            <>
              <PublicChart selectedOddsType={selectedOddsType} data={data} />
              <div className="public-showcase__caption">
                <FormattedMessage tagName="span" id="home-showcase-caption" />
              </div>
            </>
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </PublicLayoutContainer>
    </div>
  );
};

export default PublicShowcase;
